import {
  faSync,
  faThumbsDown,
  faThumbsUp,
} from "@fortawesome/pro-regular-svg-icons";
import {
  faThumbsDown as faThumbsDownSolid,
  faThumbsUp as faThumbsUpSolid,
} from "@fortawesome/pro-solid-svg-icons";

import { IconButton } from "src/design-system/Icon";
import { Tooltip } from "src/design-system/Tooltip";

type ChatActionsProps = {
  reactionStatus: "liked" | "disliked" | null;
  onLike: VoidFunction;
  onDislike: VoidFunction;
  onRegenerate: VoidFunction;
  dataLoc?: string;
};

export const ChatActions: React.FC<ChatActionsProps> = ({
  reactionStatus,
  onLike,
  onDislike,
  onRegenerate,
  dataLoc,
}) => (
  <div
    className="flex items-center gap-x-1 opacity-0 transition-opacity group-hover:opacity-100"
    data-loc={dataLoc}
  >
    <Tooltip placement="top" title="Regenerate response" asChild>
      <IconButton icon={faSync} size="xs" onClick={onRegenerate} />
    </Tooltip>
    <div className="mx-0.5 h-2.5 border-gray-200 border-l" />
    <Tooltip placement="top" title="Good response" asChild>
      <IconButton
        icon={reactionStatus === "liked" ? faThumbsUpSolid : faThumbsUp}
        size="xs"
        onClick={onLike}
      />
    </Tooltip>
    <Tooltip placement="top" title="Not good response" asChild>
      <IconButton
        icon={reactionStatus === "disliked" ? faThumbsDownSolid : faThumbsDown}
        size="xs"
        onClick={onDislike}
      />
    </Tooltip>
  </div>
);
